import Swiper from "swiper/bundle";

export default new class MainSlider {
    constructor() {
        this.sliderContainer = 'main-slider__container';
        this.sliderPagination = 'main-slider__pagination';
        this.handler();

        this.pagination = {
            el: '.main-slider__pagination',
            type: 'bullets',
            clickable: true,
            bulletClass: 'main-slider__pagination_bullet'
        };
    }

    handler() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        const { pagination } = this;
        this.MainSlider = new Swiper(`.${this.sliderContainer}`, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 2000,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            observer: true,
            loop: false,
            pagination,
            autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true,
            }
        });
    }
}();
